import { render } from "./TelInput.vue?vue&type=template&id=45e6761c&scoped=true"
import script from "./TelInput.vue?vue&type=script&lang=js"
export * from "./TelInput.vue?vue&type=script&lang=js"

import "./TelInput.vue?vue&type=style&index=0&id=45e6761c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e6761c"]])

export default __exports__